export const splitAudio = async (file: File) => {
    const arrayBuffer = await file.arrayBuffer();
    const audioContext = new AudioContext({sampleRate: 16000});
    const buffer = await audioContext.decodeAudioData(arrayBuffer);
    const split_mins = 5;
    var split_length = 16000 * split_mins * 60; //  sample rate of 16000
    var time = buffer.length / 16000.0;
    var files: File[] = [];
    for (let i = 0; i * split_length < buffer.length; i++) {
        files.push(new File([bufferToWave(buffer, i * split_length,
          Math.min(buffer.length - i * split_length, split_length))], (i * 60 * split_mins).toString() + ".wav"))
    }
    return [files, time];
}

// Convert an AudioBuffer to a Blob using WAVE representation
export const bufferToWave = (abuffer: AudioBuffer, offset: number, len: number) => {
    var length = len * 2 + 44,
        buffer = new ArrayBuffer(length),
        view = new DataView(buffer),
        channels = [],
        sample, pos = 0;
  
    // write WAVE header
    setUint32(0x46464952);                         // "RIFF"
    setUint32(length - 8);                         // file length - 8
    setUint32(0x45564157);                         // "WAVE"
  
    setUint32(0x20746d66);                         // "fmt " chunk
    setUint32(16);                                 // length = 16
    setUint16(1);                                  // PCM (uncompressed)
    setUint16(1);
    setUint32(abuffer.sampleRate);
    setUint32(abuffer.sampleRate * 2);             // avg. bytes/sec
    setUint16(2);                                  // block-align
    setUint16(16);                                 // 16-bit (hardcoded in this demo)
  
    setUint32(0x61746164);                         // "data" - chunk
    setUint32(length - pos - 4);                   // chunk length
  
    // write interleaved data
    for(let i = 0; i < abuffer.numberOfChannels; i++) {
      channels.push(abuffer.getChannelData(i));
    }
  
    while(pos < length) {
      sample = Math.max(-1, Math.min(1, channels[0][offset])); // clamp
      sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767)|0; // scale to 16-bit signed int
      view.setInt16(pos, sample, true);          // write 16-bit sample
      pos += 2;
      offset++;                                     // next source sample
    }
  
    // create Blob
    return new Blob([buffer], {type: "audio/wav"});
  
    function setUint16(data: any) {
      view.setUint16(pos, data, true);
      pos += 2;
    }
  
    function setUint32(data: any) {
      view.setUint32(pos, data, true);
      pos += 4;
    }
  }